@if (hasDivider) {
  <rt-divider />
}
<div class="inner">
  <div class="actions">
    @if (hasOptionalActions) {
      <div class="actions__additional">
        <rt-group>
          <ng-content select="rt-button.optional, a[rt-button].optional, div.optional" />
        </rt-group>
      </div>
    }
    <div class="actions__main">
      <rt-group>
        <ng-content
          select="rt-button:not(.optional), a[rt-button]:not(.optional), div:not(.optional)"
        />
      </rt-group>
    </div>
  </div>
</div>
